



















































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import { clone } from 'ramda'
import { db } from '../firebase/init'
import MainMixin from '../mixins/MainMixin'
import EventBus from '../event-bus'
import CardList from '../components/layout/CardList.vue'
import TaskWrapper from '../components/tasks/TaskWrapper.vue'
import { CustomerType, CouponType } from '../types'
import AllNotifications from '../components/notifications/AllNotifications.vue'

@Component({
  components: {
    AllNotifications,
    TaskWrapper,
  },
})
export default class Welcome extends Mixins(MainMixin) {
  note = { title: 'Out Of XX', message: '<h1> This is the test</h1><p>and more...</p>' }

  shift = ''

  shiftSelected(x:string) {
    this.shift = x
    this.$store.dispatch('setShift', x)
  }

  get userOnlineList() {
    const online:any[] = []
    const offline:any[] = []
    const { allUsers } = this.$store.getters
    const { dbUsers } = this.$store.state.appStore
    console.log('dbusers is: ', dbUsers)
    allUsers.forEach((tuser:any) => {
      const user = clone(tuser)
      console.log('user here is : ', user)
      const us = dbUsers.find((u:any) => u['.key'] === user.value)
      if (us && us.online) online.push(Object.assign(user, { online: us.online }))
      else if (us && us.online === false) {
        console.log('user test: ', us)
        offline.push(Object.assign(user, { lastSeen: us.lastOnlineChanged }))
      } else offline.push(Object.assign(user, { lastSeen: null }))
    })
    return [online, offline]
  }

  beforeDestroy() {
    this.$store.dispatch('setViewTime')
  }
}
